import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LabelSettings from './label-settings';
import { getPhoneNumberLabelsRequest, setPhoneNumberLabelRequest, getPhoneNumberDetailsRequest } from '../../../../../../../../extra-actions';
import { RootState } from '../../../../../../../../../../store/root-reducer';
import toaster, { Theme } from '../../../../../../../../../../shared/toaster';
import { executeOnRequestStatus } from '../../../../../../../../../../shared/utils';
import { resetSetPhoneNumberLabelRequest } from '../../../../../../../../dialer-slice';

const LabelSettingsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const activeNumberSettings = useSelector(
    (state: RootState) => state.dialer.activeNumberSettings,
  );
  const labelsList: string[] = useSelector(
    (state: RootState) => state?.dialer?.phoneNumberLabels || [],
  );
  const getLabelsListRequestStatus = useSelector(
    (state: RootState) => state?.dialer?.getPhoneNumberLabelsRequest,
  );
  const setPhoneNumberLabelRequestStatus = useSelector(
    (state: RootState) => state.dialer.setPhoneNumberLabelRequest.status,
  );

  const getLabelsListRequest = useCallback(
    (search?: string) => {
      dispatch(getPhoneNumberLabelsRequest({ search }));
    },
    [dispatch],
  );

  const handleSave = useCallback(
    (phoneNumberId: number, label: string) => {
      dispatch(
        setPhoneNumberLabelRequest({
          phoneNumberIds: [phoneNumberId],
          label,
        }),
      );
    },
    [dispatch],
  );

  // Show success toaster when label update succeeds
  useEffect(() => {
    executeOnRequestStatus({
      status: setPhoneNumberLabelRequestStatus,
      onSuccess: () => {
        toaster.success('Number Setting Updated Successfully', { theme: Theme.New });
        dispatch(getPhoneNumberDetailsRequest(activeNumberSettings?.id as number));
        dispatch(resetSetPhoneNumberLabelRequest());
      },
      onFailed: () => {
        dispatch(resetSetPhoneNumberLabelRequest());
      },
    });
  }, [setPhoneNumberLabelRequestStatus, dispatch, activeNumberSettings?.id]);

  // Fetch labels when component mounts
  useEffect(() => {
    getLabelsListRequest();
  }, [getLabelsListRequest]);

  return (
    <LabelSettings
      activeNumberSettings={activeNumberSettings}
      labelsList={labelsList}
      getLabelsListRequestStatus={getLabelsListRequestStatus}
      setPhoneNumberLabelRequestStatus={setPhoneNumberLabelRequestStatus}
      onSave={handleSave}
    />
  );
};

export default memo(LabelSettingsContainer);

